import { render, staticRenderFns } from "./CommonMagic.vue?vue&type=template&id=dde9cfae&scoped=true"
import script from "./CommonMagic.vue?vue&type=script&lang=js"
export * from "./CommonMagic.vue?vue&type=script&lang=js"
import style0 from "./CommonMagic.vue?vue&type=style&index=0&id=dde9cfae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde9cfae",
  null
  
)

export default component.exports